
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
@Component
export default class SearchName extends Vue {
  private name: string = "";
  @Emit("getBoxName")
  sendName(name: string) {}
}
